/** Whether a full actors payload differs from the last one applied (the keyframe throttle gate). */
export function actorsChanged(
  prev: {
    address: number;
    x: number;
    y: number;
    z: number;
    hidden?: boolean;
    discovered?: boolean;
    despawnAt?: number;
  }[],
  next: {
    address: number;
    x: number;
    y: number;
    z: number;
    hidden?: boolean;
    discovered?: boolean;
    despawnAt?: number;
  }[],
): boolean {
  if (prev.length !== next.length) return true;
  for (let i = 0; i < prev.length; i++) {
    const a = prev[i];
    const b = next[i];
    if (
      a.address !== b.address ||
      a.x !== b.x ||
      a.y !== b.y ||
      a.z !== b.z ||
      a.hidden !== b.hidden ||
      // A looted chest / picked effigy flips only this flag: a keyframe carrying just that
      // change must not be skipped as "unchanged".
      a.discovered !== b.discovered ||
      a.despawnAt !== b.despawnAt
    ) {
      return true;
    }
  }
  return false;
}
